const excludedFilters = ['period', 'from', 'to'];

export default excludedFilters;
